import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";
import {
  encryptString,
  createSession,
  getAbhaProfile,
} from "../../services/apiUtils";
import Loader from "../../components/common/Loader";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { API_BASE_URL } from "../../config";
import { toast, ToastContainer } from "react-toastify";
import DeactivatePopup from "../../components/Forgot-ABHA/Account-deactivate-popup";
import authService from "../../../Services/authService";
import AadharConsentSection from "../common/AadharConsentSection";

const LoginAadharNumber = () => {
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [formateAadhar, setFormateAadhar] = useState("");
  const [aadharno, setAadharno] = useState("");
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [accessToken, setaccessToken] = useState("");
  const [aadharEncrpt, setEncrptAadhar] = useState("");
  const [txnId, settxnId] = useState("");
  const [resendTimer, setResendTimer] = useState("");
  const [OtpText, setOtpText] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [showDeactivateMessage, setShowDeactivateMessage] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaSessionId, setCaptchaSessionId] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [showAadhar, setShowAadhar] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [resendCount, setResendCount] = useState(1);
  const [consent1, setConsent1] = useState(false);
  const [consent2, setConsent2] = useState(false);
  const [consent3, setConsent3] = useState(false);
  const [consent4, setConsent4] = useState(false);
  const [consent5, setConsent5] = useState(false);
  const [consent6, setConsent6] = useState(false);
  const [consent7, setConsent7] = useState(false);
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [acceptAll, setAcceptAll] = useState(false);
  const [healthcareWorkerName] = useState(() => {
    try {
      const userData = authService.getUser();
      return (
        userData?.name ||
        userData?.username ||
        userData?.email?.split("@")[0] ||
        "Healthcare Worker"
      );
    } catch {
      return "Healthcare Worker";
    }
  });
  const [showMoreConsent, setShowMoreConsent] = useState(false);
  const [aadharError, setAadharError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [otpError, setOtpError] = useState("");

  const navigate = useNavigate();

  const { getDataByKey } = useContext(GlobalContext);
  const back = () => {
    if (showOtpBox) {
      setShowOtpBox(false);
      setResendCount(1);
    } else {
      getDataByKey("backfunction")?.();
    }
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  // Handle Accept All checkbox
  const handleAcceptAll = (checked) => {
    setAcceptAll(checked);
    setConsent1(checked);
    setConsent2(checked);
    setConsent3(checked);
    setConsent4(checked);
    setConsent5(checked);
    setConsent6(checked);
    setConsent7(checked);
  };

  // Update Accept All when individual consents change
  useEffect(() => {
    const allChecked =
      consent1 &&
      consent2 &&
      consent3 &&
      consent4 &&
      consent5 &&
      consent6 &&
      consent7;
    setAcceptAll(allChecked);
  }, [consent1, consent2, consent3, consent4, consent5, consent6, consent7]);

  // Check if all required consents are checked
  const areAllConsentsChecked = () => {
    return (
      consent1 &&
      consent2 &&
      consent3 &&
      consent4 &&
      consent5 &&
      consent6 &&
      consent7 &&
      beneficiaryName.trim() !== ""
    );
  };

  // Fetch captcha from backend
  const generateCaptcha = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/abha/captcha/generate`);
      if (response.data.success) {
        setCaptchaSessionId(response.data.data.sessionId);
        setCaptchaImage(response.data.data.captchaImage);
        setCaptchaInput("");
      } else {
        toast.error("Failed to generate captcha. Please try again.");
      }
    } catch (error) {
      console.error("Error generating captcha:", error);
      toast.error("Failed to generate captcha. Please try again.");
    }
  };

  // Toggle Aadhar visibility
  const toggleAadharVisibility = () => {
    setShowAadhar(!showAadhar);
    // Reformat the display
    if (!showAadhar && aadharno) {
      // Switching to visible - format with dashes
      let formatted = aadharno;
      if (aadharno.length > 4) {
        formatted = aadharno.slice(0, 4) + "-" + aadharno.slice(4);
      }
      if (aadharno.length > 8) {
        formatted =
          aadharno.slice(0, 4) +
          "-" +
          aadharno.slice(4, 8) +
          "-" +
          aadharno.slice(8);
      }
      setFormateAadhar(formatted);
    } else if (aadharno) {
      // Switching to masked - show asterisks with dashes
      const stars = aadharno
        .split("")
        .map(() => "*")
        .join("");
      let masked = "";
      if (aadharno.length <= 4) {
        masked = stars;
      } else if (aadharno.length <= 8) {
        masked = stars.slice(0, 4) + "-" + stars.slice(4);
      } else {
        masked =
          stars.slice(0, 4) + "-" + stars.slice(4, 8) + "-" + stars.slice(8);
      }
      setFormateAadhar(masked);
    }
  };

  // Initialize captcha on mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  /**
   * function used to formate ABHA no. in input box with mask/unmask support
   */
  const handleFormateAadhar = (e) => {
    const inputValue = e.target.value;

    if (showAadhar) {
      // When visible, extract numeric values and format with dashes
      const numericValue = inputValue.replace(/\D/g, "");
      const limitedValue = numericValue.slice(0, 12);
      setAadharno(limitedValue);

      // Format as xxxx-xxxx-xxxx or xxxx-xxxx-xxxx-xxxx
      let formatted = limitedValue;
      if (limitedValue.length > 4) {
        formatted = limitedValue.slice(0, 4) + "-" + limitedValue.slice(4);
      }
      if (limitedValue.length > 8) {
        formatted =
          limitedValue.slice(0, 4) +
          "-" +
          limitedValue.slice(4, 8) +
          "-" +
          limitedValue.slice(8);
      }
      setFormateAadhar(formatted);

      // Validate Aadhaar for visible input
      if (limitedValue.length === 0) {
        setAadharError("Aadhaar number is required");
      } else if (limitedValue.length !== 12) {
        setAadharError("Aadhaar number must be 12 digits");
      } else {
        setAadharError("");
      }
    } else {
      // When masked, compare lengths to determine if adding or removing
      const currentLength = formateAadhar.length;
      const newLength = inputValue.length;

      if (newLength > currentLength) {
        // User is adding a digit - extract the new digit
        const newDigit = inputValue.replace(/\D/g, "").slice(-1);
        if (newDigit && aadharno.length < 12) {
          const updatedValue = aadharno + newDigit;
          setAadharno(updatedValue);

          const stars = updatedValue
            .split("")
            .map(() => "*")
            .join("");
          let masked = "";
          if (updatedValue.length <= 4) {
            masked = stars;
          } else if (updatedValue.length <= 8) {
            masked = stars.slice(0, 4) + "-" + stars.slice(4);
          } else {
            masked =
              stars.slice(0, 4) +
              "-" +
              stars.slice(4, 8) +
              "-" +
              stars.slice(8);
          }
          setFormateAadhar(masked);
        }
      } else if (newLength < currentLength) {
        // User is removing a digit (backspace)
        const updatedValue = aadharno.slice(0, -1);
        setAadharno(updatedValue);

        const stars = updatedValue
          .split("")
          .map(() => "*")
          .join("");
        let masked = "";
        if (updatedValue.length <= 4) {
          masked = stars;
        } else if (updatedValue.length <= 8) {
          masked = stars.slice(0, 4) + "-" + stars.slice(4);
        } else {
          masked =
            stars.slice(0, 4) + "-" + stars.slice(4, 8) + "-" + stars.slice(8);
        }
        setFormateAadhar(masked);
      }

      // Validate Aadhaar for masked input
      const currentAadharLength =
        aadharno.length + (newLength > currentLength ? 1 : -1);
      if (currentAadharLength === 0) {
        setAadharError("Aadhaar number is required");
      } else if (currentAadharLength !== 12) {
        setAadharError("Aadhaar number must be 12 digits");
      } else {
        setAadharError("");
      }
    }
  };
  /**
   * Function used to set otp text
   */
  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only digits and up to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setOtpText(value);
    }
  };
  const sendOtpRequest = async (encryptedAadhar) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/abha/api/v3/profile/login/request/otp`,
        {
          scope: ["abha-login", "aadhaar-verify"],
          loginHint: "aadhaar",
          loginId: encryptedAadhar,
          otpSystem: "aadhaar",
        },
        {
          headers: {
            "Content-Type": "application/json",
            "REQUEST-ID": uuidv4(),
            TIMESTAMP: new Date().toISOString(), // Generate the current timestamp dynamically
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server responded with a status:", error.response.status);
        console.error("Response data:", error.response.data);
      } else if (error.request) {
        console.error(
          "Request was made, but no response received:",
          error.request,
        );
      } else {
        console.error("Error in setting up the request:", error.message);
      }
    }
  };

  // Trigger when accessToken changes
  useEffect(() => {
    const sendOtpIfReady = async () => {
      if (accessToken && aadharEncrpt) {
        try {
          const response = await sendOtpRequest(aadharEncrpt);
          if (response?.txnId) {
            setErrorMessage(response.message);
            settxnId(response.txnId);
            setShowOtpBox(true);
            setIsPageLoading(false);
            setResendTimer(60); // Example: 60 seconds
          }
        } catch (error) {
          if (error?.message) {
            setErrorMessage(error.message);
          } else {
            setErrorMessage("Something went wrong!!");
          }
          setIsPageLoading(false);
        } finally {
          setIsPageLoading(false);
        }
      }
    };
    sendOtpIfReady();
  }, [accessToken, aadharEncrpt]);

  // Countdown logic using useEffect
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
      return () => clearTimeout(timer); // Cleanup timer on unmount
    }
  }, [resendTimer]);

  /**
   * function used to send otp for abha verification
   */
  const handleSendOtp = async (event) => {
    event.preventDefault();

    if (!aadharno || aadharno.length !== 12) {
      toast.error("Please enter a valid Aadhaar number (12 digits).");
      return;
    }

    // Validate beneficiary name
    if (!beneficiaryName || beneficiaryName.trim() === "") {
      toast.error("Please enter beneficiary name.");
      return;
    }

    // Validate consents
    if (!areAllConsentsChecked()) {
      toast.error("Please accept the required terms and conditions.");
      return;
    }

    // Validate captcha with backend
    if (!captchaInput || captchaInput.trim() === "") {
      toast.error("Please enter the captcha.");
      return;
    }

    try {
      // Verify captcha with backend
      const captchaResponse = await axios.post(
        `${API_BASE_URL}/abha/captcha/validate`,
        {
          sessionId: captchaSessionId,
          captcha: captchaInput,
        },
      );

      if (!captchaResponse.data.success || !captchaResponse.data.valid) {
        toast.error("Invalid captcha. Please try again.");
        generateCaptcha(); // Regenerate captcha
        setCaptchaInput(""); // Clear input
        return;
      }
    } catch (error) {
      toast.error("Failed to validate captcha. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    setIsPageLoading(true);
    try {
      // Encrypt Aadhaar
      const encryptedAadharNo = await encryptString(aadharno);
      if (encryptedAadharNo) {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const url = `${API_BASE_URL}/abha/login/aadhar/send-otp`;
          const param = {
            aadharNumber: encryptedAadharNo,
          };
          // const accessToken = sessionResponse.accessToken;
          // setaccessToken(accessToken);
          const header = {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: sessionResponse.accessToken,
            },
          };
          const response = await axios.post(url, param, header);
          const dtResponse = response.data;
          if (dtResponse.success) {
            settxnId(dtResponse.data?.txnId);
            setShowOtpBox(true);
            setResendTimer(60);

            toast.success(dtResponse?.data.message || "OTP sent successfully.");
            setIsPageLoading(false);
          } else {
            toast.error(
              dtResponse?.data.message ||
                "Failed to send OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } else {
        toast.error("Failed to encrypt ABHA number. Please try again.");
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        const errorMessage = error.response.data.error.loginId;
        toast.error(
          errorMessage === "LoginId is invalid"
            ? "Aadhar Number is not valid"
            : errorMessage || "Failed to send OTP. Please try again.",
        );
      } else {
        const errorMessage = error.response.data.error.loginId;
        toast.error(
          errorMessage === "LoginId is invalid"
            ? "Aadhar Number is not valid"
            : errorMessage || "Failed to send OTP. Please try again.",
        );
      }
    }
  };

  /**
   * Function used to resend OTP
   */
  const handleResendOtp = async () => {
    if (resendCount >= 3) {
      toast.error("Maximum resend attempts reached.");
      return;
    }
    if (resendTimer > 0) {
      toast.error("Please wait before resending OTP.");
      return;
    }

    setIsPageLoading(true);
    try {
      const encryptedAadharNo = await encryptString(aadharno);
      if (encryptedAadharNo) {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const url = `${API_BASE_URL}/abha/login/aadhar/send-otp`;
          const param = {
            aadharNumber: encryptedAadharNo,
          };
          const header = {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: sessionResponse.accessToken,
            },
          };
          const response = await axios.post(url, param, header);
          const dtResponse = response.data;
          if (dtResponse.success) {
            settxnId(dtResponse.data?.txnId);
            setResendTimer(60);
            setResendCount(resendCount + 1);
            toast.success(
              dtResponse.data.message || "OTP resent successfully.",
            );
            setIsPageLoading(false);
          } else {
            toast.error(
              dtResponse?.data.message ||
                "Failed to resend OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } else {
        toast.error("Failed to encrypt ABHA number. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Failed to resend OTP. Please try again.",
      );
    }
  };

  /**
   * Functin used to verify abha number
   */
  const verifyOtp = async (event) => {
    event.preventDefault();
    setIsPageLoading(true);
    try {
      const encryptedOtp = await encryptString(OtpText);
      if (encryptedOtp) {
        const url = `${API_BASE_URL}/abha/login/aadhar/verify-otp`;
        const param = {
          txnId: txnId,
          otp: encryptedOtp,
        };
        const header = {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: accessToken,
          },
        };
        const response = await axios.post(url, param, header);
        const dtResponse = response.data;
        if (dtResponse.success) {
          if (dtResponse.data.authResult === "success") {
            // localStorage.setItem("x_token", dtResponse.data.token);
            localStorage.setItem("loginMethod", "aadhar");
            // get ABHA profile data
            const abhaProfileData = await getAbhaProfile(
              null,
              dtResponse.data.token,
            );
            if (abhaProfileData?.success) {
              localStorage.setItem(
                "orignalBeneficiaryData",
                JSON.stringify(abhaProfileData?.data),
              );
              localStorage.setItem(
                "abhaProfileData",
                JSON.stringify(abhaProfileData),
              );
              setIsPageLoading(false);
              navigate("/abha-Card");
            } else {
              toast.error(
                abhaProfileData?.message ||
                  "Failed to fetch ABHA profile data. Please try again.",
              );
              setIsPageLoading(false);
              return;
            }
          } else {
            toast.error(
              dtResponse?.data?.message || "Wrong OTP. Please try again.",
            );
            setIsPageLoading(false);
            return;
          }
        } else {
          toast.error(
            dtResponse?.error?.error?.message ||
              dtResponse?.data?.message ||
              "Failed to verify OTP. Please try again.",
          );
          setIsPageLoading(false);
        }
      } else {
        toast.error("Failed to encrypt OTP. Please try again.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      // Backend returned an error response
      if (
        error.response.data.success === false &&
        error.response.data.message === "Unclassified Authentication Failure"
      ) {
        toast.error(error.response.data.message + ". Please try again!");
      } else if (
        error.response.data.success === false &&
        error.response.data.message ===
          "This account is deactivated. Please continue to reactivate."
      ) {
        setShowDeactivateMessage(error.response.data.message);
      } else {
        toast.error(
          error.response?.data?.error?.error?.message ||
            error.response?.data?.message ||
            "Server error occurred. Please try again later.",
        );
      }
    }
  };

  return (
    <>
      {showDeactivateMessage && (
        <DeactivatePopup
          onClose={() => setShowDeactivateMessage("")}
          showDeactivateMessage={showDeactivateMessage}
        />
      )}
      <ToastContainer />
      {isPageLoading && <Loader />}
      <div className="flow-feilds">
        {!showOtpBox && (
          <>
            <div className="feilds">
              <label>
                Aadhar Number <span style={{ color: "red" }}>*</span>
              </label>
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  type="text"
                  className="filds-form"
                  placeholder="Enter 12 digit Aadhar"
                  value={formateAadhar}
                  autoComplete="off"
                  maxLength={14}
                  onChange={handleFormateAadhar}
                  style={{ paddingRight: "40px", width: "100%" }}
                />
                <i
                  className="material-icons"
                  onClick={toggleAadharVisibility}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "20px",
                  }}
                >
                  {showAadhar ? "visibility" : "visibility_off"}
                </i>
              </div>
              {aadharError && (
                <span
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {aadharError}
                </span>
              )}
            </div>

            <div className="feilds" style={{ marginTop: "15px" }}>
              <div
                style={{
                  backgroundColor: "#f5f5f5",
                  padding: "15px",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                }}
              >
                {/* Name Input Fields */}
                <div style={{ marginBottom: "15px" }}>
                  <div className="feilds" style={{ marginBottom: "15px" }}>
                    <label
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        marginBottom: "5px",
                        display: "block",
                      }}
                    >
                      Beneficiary Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="filds-form"
                      placeholder="Enter beneficiary name"
                      value={beneficiaryName}
                      onChange={(e) => setBeneficiaryName(e.target.value)}
                      style={{
                        width: "100%",
                        fontSize: "13px",
                        padding: "8px",
                      }}
                    />
                  </div>
                </div>
                <AadharConsentSection
                  acceptAll={acceptAll}
                  handleAcceptAll={handleAcceptAll}
                  consent1={consent1}
                  setConsent1={setConsent1}
                  consent2={consent2}
                  setConsent2={setConsent2}
                  consent3={consent3}
                  setConsent3={setConsent3}
                  consent4={consent4}
                  setConsent4={setConsent4}
                  consent5={consent5}
                  setConsent5={setConsent5}
                  consent6={consent6}
                  setConsent6={setConsent6}
                  consent7={consent7}
                  setConsent7={setConsent7}
                  beneficiaryName={beneficiaryName}
                  setBeneficiaryName={setBeneficiaryName}
                  healthcareWorkerName={healthcareWorkerName}
                />
              </div>
            </div>

            <div className="feilds" style={{ marginTop: "15px" }}>
              <label>
                Captcha <span style={{ color: "red" }}>*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#f0f0f0",
                    padding: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    flex: 1,
                    textAlign: "center",
                    userSelect: "none",
                    minHeight: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {captchaImage ? (
                    <img
                      src={captchaImage}
                      alt="Captcha"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  ) : (
                    <span style={{ color: "#999" }}>Loading captcha...</span>
                  )}
                </div>
                <i
                  className="material-icons"
                  onClick={generateCaptcha}
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  title="Refresh Captcha"
                >
                  refresh
                </i>
              </div>
              <input
                type="text"
                className="filds-form"
                placeholder="Enter captcha text"
                value={captchaInput}
                autoComplete="off"
                onChange={(e) => {
                  setCaptchaInput(e.target.value);
                }}
              />
            </div>
          </>
        )}
        {showOtpBox && (
          <>
            <div className="feilds">
              <label>Aadhar Number</label>
              <input
                type="text"
                className="filds-form"
                value={"*".repeat(8) + aadharno.slice(-4)}
                disabled
                style={{ background: "#f5f5f5", cursor: "not-allowed" }}
              />
            </div>
            <div className="feilds">
              <label>
                Confirm OTP <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="filds-form"
                placeholder="Enter 6 digit OTP"
                value={OtpText}
                autoComplete="off"
                maxLength={6}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  handleOtpChange({ target: { value } });
                  if (value.length === 0) {
                    setOtpError("OTP is required");
                  } else if (value.length < 6) {
                    setOtpError("OTP must be 6 digits");
                  } else {
                    setOtpError("");
                  }
                }}
              />
              {otpError && (
                <span
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {otpError}
                </span>
              )}
              <span
                className="notes text-end"
                onClick={
                  resendTimer === 0 && resendCount < 3 ? handleResendOtp : null
                }
                style={{
                  pointerEvents:
                    resendTimer > 0 || resendCount >= 3 ? "none" : "auto",
                  color:
                    resendTimer > 0 || resendCount >= 3 ? "#999" : "#007bff",
                  cursor:
                    resendTimer > 0 || resendCount >= 3
                      ? "not-allowed"
                      : "pointer",
                  display: "block",
                  marginTop: "5px",
                }}
              >
                {resendTimer > 0
                  ? `00:${resendTimer < 10 ? "0" + resendTimer : resendTimer} Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`
                  : resendCount >= 3
                    ? "Maximum resend attempts reached"
                    : `Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`}
              </span>
            </div>
          </>
        )}
      </div>

      <div className="flow-feilds" style={{ minHeight: "auto" }}>
        <div className="feilds feildsBtn">
          <button className="custBtn btnCancel" onClick={back}>
            Back
          </button>
          {!showOtpBox ? (
            <button
              className={`custBtn ${aadharno.length === 12 ? "btnSuccess" : "disabled"}`}
              disabled={aadharno.length !== 12}
              onClick={handleSendOtp}
            >
              Continue <i className="material-icons">arrow_right_alt</i>
            </button>
          ) : (
            <button
              className={`custBtn ${OtpText.length === 6 ? "btnSuccess" : "disabled"}`}
              disabled={OtpText.length !== 6}
              onClick={verifyOtp}
            >
              Verify <i className="material-icons">arrow_right_alt</i>
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginAadharNumber;
